import React from 'react';
import SearchForm from '../components/SearchContent/SearchForm';
import SearchTransfer from '../components/SearchContent/Transfers/SearchTransfer';
import { translate } from 'react-i18next';
import ExclusiveForm from '../components/SearchContent/ExclusiveForm';
import { getUserInformation } from '../components/Login/loginService';
import { getCMSConfiguration } from './../cms/cmsLib';

import {dataService} from './SearchTabs';

class SearchFormTabs extends React.Component {
    constructor(props, context) {
        super(props);
        this.state = {
            currentHash: 'loading'
        };
        this.currentUser = getUserInformation();

    }
    componentDidMount() {
        window.addEventListener('hashchange', this.checkHash, false);
        this.checkHash();
        
        // Subscriber to know the current selected tab
        dataService.getData().subscribe(value => {
            this.selectedTab = value.tab;
        });
    }

    componentWillUnmount() {
        window.removeEventListener('hashchange', this.checkHash, false);
    }

    checkHash = () => {

        //esto es mas flojito que gago pero bueno.
        let hash = window.location.hash;
        hash = hash.replace(/\?.+/, '');
        try {
            let page = hash.split('/')[2];
            page = unescape(page);
            if (page == undefined || page == 'undefined') {
                page = 'hotels';
            }
            this.setState({ currentHash: page });
        } catch (e) {
            this.setState({ currentHash: 'hotels' });
        }
    }
    render() {
        const { isDisabled, widget1Active } = this.props;
        
        // load the default tab if none is selected
        if (!this.selectedTab) {
            let cmsConf = getCMSConfiguration();

            let tabOrderNumber = Number(this.state.currentHash);
            this.selectedTab = cmsConf['tabs'].find(x => x.orden === tabOrderNumber);
 
            // if the selected tab not exist, make a redirect to the first tab by order
            if (!this.selectedTab && cmsConf['tabs'] && cmsConf['tabs'][0]) {
                window.location.href = '#/search/' + cmsConf['tabs'][0].orden;
            }
            
            localStorage.setItem('selectedTab', JSON.stringify(this.selectedTab));
        }
        return <div className="cmsSearchFormTabs">        
            {this.selectedTab && this.selectedTab.type.id === 'H' ? <SearchForm widget1Active={widget1Active} isDisabled={isDisabled} user={this.currentUser} tab={this.selectedTab} /> : ''}
            {this.selectedTab && this.selectedTab.type.id === 'T' ? <SearchTransfer user={this.currentUser}/> : ''}
            {this.selectedTab && this.selectedTab.type.id === 'DS' ? <SearchForm widget1Active={widget1Active} isDisabled={isDisabled} user={this.currentUser} tab={this.selectedTab}/> : ''}
            {this.selectedTab && this.selectedTab.type.id === 'HS' ? <SearchForm widget1Active={widget1Active} isDisabled={isDisabled} user={this.currentUser} tab={this.selectedTab}/> : ''}
        </div>;
    }
}

SearchFormTabs.defaultProps = {
    widget1Active: false
};

export default translate('translations')(SearchFormTabs);


// WEBPACK FOOTER //
// ./src/cms/SearchFormTabs.js